import { useCallback } from 'react';

import { useQueryClient } from '@lumapps/base-api/react-query';
import { useSelector } from '@lumapps/redux/react';
import { currentLanguageSelector } from '@lumapps/translations/ducks/selectors';
import { interestQueryKeys } from '@lumapps/widget-content-filter/api/followInterest';

export const useInvalidateFollowedInterests = () => {
    const queryClient = useQueryClient();
    const lang = useSelector(currentLanguageSelector);

    const invalidateFollowedInterests = useCallback(async () => {
        await queryClient.invalidateQueries(interestQueryKeys.listAlreadyFollowed(lang));
    }, [lang, queryClient]);

    return { invalidateFollowedInterests };
};
